export const EVENTS = {
  account_setup_instruction_start: 'account_setup_instruction_start',
  account_setup_instruction_end: 'account_setup_instruction_end',
  account_setup_basic_information_start: 'account_setup_basic_information_start',
  account_setup_basic_information_change: 'account_setup_basic_information_change',
  account_setup_basic_information_end: 'account_setup_basic_information_end',
  account_setup_contact_information_start: 'account_setup_contact_information_start',
  account_setup_contact_information_change: 'account_setup_contact_information_change',
  account_setup_contact_information_end: 'account_setup_contact_information_end',
  account_setup_location_start: 'account_setup_location_start',
  account_setup_location_change: 'account_setup_location_change',
  account_setup_location_end: 'account_setup_location_end',
  account_setup_profile_start: 'account_setup_profile_start',
  account_setup_profile_change: 'account_setup_profile_change',
  account_setup_profile_end: 'account_setup_profile_end',
  account_setup_status_complete: 'account_setup_status_complete',
  account_setup_close: 'account_setup_close',

  network_setup_instruction_start: 'network_setup_instruction_start',
  network_setup_instruction_end: 'network_setup_instruction_end',
  network_setup_immediate_family_start: 'network_setup_immediate_family_start',
  network_setup_immediate_family_add_change: 'network_setup_immediate_family_add_change',
  network_setup_immediate_family_edit_change: 'network_setup_immediate_family_edit_change',
  network_setup_immediate_family_delete_change: 'network_setup_immediate_family_delete_change',
  network_setup_immediate_family_end: 'network_setup_immediate_family_end',
  network_setup_in_laws_start: 'network_setup_in_laws_start',
  network_setup_in_laws_add_change: 'network_setup_in_laws_add_change',
  network_setup_in_laws_edit_change: 'network_setup_in_laws_edit_change',
  network_setup_in_laws_delete_change: 'network_setup_in_laws_delete_change',
  network_setup_in_laws_end: 'network_setup_in_laws_end',
  network_setup_extended_family_start: 'network_setup_extended_family_start',
  network_setup_extended_family_add_change: 'network_setup_extended_family_add_change',
  network_setup_extended_family_edit_change: 'network_setup_extended_family_edit_change',
  network_setup_extended_family_delete_change: 'network_setup_extended_family_delete_change',
  network_setup_extended_family_end: 'network_setup_extended_family_end',
  network_setup_other_relationship_start: 'network_setup_other_relationship_start',
  network_setup_other_relationship_add_change: 'network_setup_other_relationship_add_change',
  network_setup_other_relationship_edit_change: 'network_setup_other_relationship_edit_change',
  network_setup_other_relationship_delete_change: 'network_setup_other_relationship_delete_change',
  network_setup_other_relationship_end: 'network_setup_other_relationship_end',
  network_setup_service_providers_start: 'network_setup_service_providers_start',
  network_setup_service_providers_add_change: 'network_setup_service_providers_add_change',
  network_setup_service_providers_edit_change: 'network_setup_service_providers_edit_change',
  network_setup_service_providers_delete_change: 'network_setup_service_providers_delete_change',
  network_setup_service_providers_end: 'network_setup_service_providers_end',
  network_setup_staff_start: 'network_setup_staff_start',
  network_setup_staff_add_change: 'network_setup_staff_add_change',
  network_setup_staff_edit_change: 'network_setup_staff_edit_change',
  network_setup_staff_delete_change: 'network_setup_staff_delete_change',
  network_setup_staff_end: 'network_setup_staff_end',

  network_setup_professional_start: 'network_setup_professional_start',
  network_setup_professional_add_change: 'network_setup_professional_add_change',
  network_setup_professional_edit_change: 'network_setup_professional_edit_change',
  network_setup_professional_delete_change: 'network_setup_professional_delete_change',
  network_setup_professional_end: 'network_setup_professional_end',

  network_setup_status_complete: 'network_setup_status_complete',
  network_setup_close: 'network_setup_close',

  about_mfo_instruction_start: 'about_mfo_instruction_start',
  about_mfo_instruction_end: 'about_mfo_instruction_end',
  about_mfo_security_start: 'about_mfo_security_start',
  about_mfo_security_end: 'about_mfo_security_end',
  about_mfo_basics_start: 'about_mfo_basics_start',
  about_mfo_basics_end: 'about_mfo_basics_end',
  about_mfo_status_start: 'about_mfo_status_start',
  about_mfo_status_complete: 'about_mfo_status_complete',
  about_mfo_close: 'about_mfo_close',

  network_responsibilities_start: 'network_responsibilities_start',
  network_responsibilities_end: 'network_responsibilities_end',
  network_responsibilities_myrespons_start: 'network_responsibilities_myrespons_start',
  network_responsibilities_myrespons_end: 'network_responsibilities_myrespons_end',
  network_responsibilities_status_complete: 'network_responsibilities_status_complete',
  network_responsibilities_close: 'network_responsibilities_close',

  security_privacy_instruction_start: 'security_privacy_instruction_start',
  security_privacy_instruction_end: 'security_privacy_instruction_end',
  security_privacy_2fa_start: 'security_privacy_2fa_start',
  security_privacy_2fa_change: 'security_privacy_2fa_change',
  security_privacy_2fa_end: 'security_privacy_2fa_end',
  security_privacy_search_visibility_start: 'security_privacy_search_visibility_start',
  security_privacy_search_visibility_change: 'security_privacy_search_visibility_change',
  security_privacy_search_visibility_end: 'security_privacy_search_visibility_end',
  security_privacy_premium_keys_start: 'security_privacy_premium_keys_start',
  security_privacy_premium_keys_change: 'security_privacy_premium_keys_change',
  security_privacy_premium_keys_end: 'security_privacy_premium_keys_end',
  security_privacy_status_complete: 'security_privacy_status_complete',
  security_privacy_setup_close: 'security_privacy_setup_close',

  personal_vault_setup_about_start: 'personal_vault_setup_about_start',
  personal_vault_setup_about_end: 'personal_vault_setup_about_end',
  personal_vault_setup__member_start: 'personal_vault_setup__member_start',
  personal_vault_setup_add_member_change: 'personal_vault_setup_add_member_change',
  personal_vault_setup_remove_member_change: 'personal_vault_setup_remove_member_change',
  personal_vault_setup__member_end: 'personal_vault_setup__member_end',
  personal_vault_setup_admins_start: 'personal_vault_setup_admins_start',
  personal_vault_setup_add_admins_change: 'personal_vault_setup_add_admins_change',
  personal_vault_setup_remove_admins_change: 'personal_vault_setup_remove_admins_change',
  personal_vault_setup_admins_end: 'personal_vault_setup_admins_end',
  personal_vault_setup_sharing_start: 'personal_vault_setup_sharing_start',
  personal_vault_setup_add_sharing_change: 'personal_vault_setup_add_sharing_change',
  personal_vault_setup_edit_sharing_change: 'personal_vault_setup_edit_sharing_change',
  personal_vault_setup_remove_sharing_change: 'personal_vault_setup_remove_sharing_change',
  personal_vault_setup_sharing_end: 'personal_vault_setup_sharing_end',
  personal_vault_setup_status_complete: 'personal_vault_setup_status_complete',
  personal_vault_setup_close: 'personal_vault_setup_close',

  shared_vault_setup_about_start: 'shared_vault_setup_about_start',
  shared_vault_setup_about_end: 'shared_vault_setup_about_end',
  shared_vault_setup__member_start: 'shared_vault_setup__member_start',
  shared_vault_setup_add_member_change: 'shared_vault_setup_add_member_change',
  shared_vault_setup_remove_member_change: 'shared_vault_setup_remove_member_change',
  shared_vault_setup__member_end: 'shared_vault_setup__member_end',
  shared_vault_setup_admins_start: 'shared_vault_setup_admins_start',
  shared_vault_setup_add_admins_change: 'shared_vault_setup_add_admins_change',
  shared_vault_setup_remove_admins_change: 'shared_vault_setup_remove_admins_change',
  shared_vault_setup_admins_end: 'shared_vault_setup_admins_end',
  shared_vault_setup_sharing_start: 'shared_vault_setup_sharing_start',
  shared_vault_setup_add_sharing_change: 'shared_vault_setup_add_sharing_change',
  shared_vault_setup_edit_sharing_change: 'shared_vault_setup_edit_sharing_change',
  shared_vault_setup_remove_sharing_change: 'shared_vault_setup_remove_sharing_change',
  shared_vault_setup_sharing_end: 'shared_vault_setup_sharing_end',
  shared_vault_setup_status_complete: 'shared_vault_setup_status_complete',
  shared_vault_setup_close: 'shared_vault_setup_close',

  entity_vault_setup_about_start: 'entity_vault_setup_about_start',
  entity_vault_setup_about_end: 'entity_vault_setup_about_end',
  entity_vault_setup__member_start: 'entity_vault_setup__member_start',
  entity_vault_setup_add_member_change: 'entity_vault_setup_add_member_change',
  entity_vault_setup_remove_member_change: 'entity_vault_setup_remove_member_change',
  entity_vault_setup__member_end: 'entity_vault_setup__member_end',
  entity_vault_setup_admins_start: 'entity_vault_setup_admins_start',
  entity_vault_setup_add_admins_change: 'entity_vault_setup_add_admins_change',
  entity_vault_setup_remove_admins_change: 'entity_vault_setup_remove_admins_change',
  entity_vault_setup_admins_end: 'entity_vault_setup_admins_end',
  entity_vault_setup_sharing_start: 'entity_vault_setup_sharing_start',
  entity_vault_setup_add_sharing_change: 'entity_vault_setup_add_sharing_change',
  entity_vault_setup_edit_sharing_change: 'entity_vault_setup_edit_sharing_change',
  entity_vault_setup_remove_sharing_change: 'entity_vault_setup_remove_sharing_change',
  entity_vault_setup_sharing_end: 'entity_vault_setup_sharing_end',
  entity_vault_setup_status_complete: 'entity_vault_setup_status_complete',
  entity_vault_setup_close: 'entity_vault_setup_close',

  vault_group_manage_group_start: 'vault_group_manage_group_start',
  vault_group_manage_group_close: 'vault_group_manage_group_close',
  vault_group_add_discovery_group: 'vault_group_add_discovery_group',
  vault_group_edit_discovery_group: 'vault_group_edit_discovery_group',
  vault_group_delete_discovery_master: 'vault_group_delete_discovery_master',
  vault_group_delete_discovery_master_path: 'vault_group_delete_discovery_master_path',
  vault_group_manage_vault_start: 'vault_group_manage_vault_start',
  vault_group_manage_vault_close: 'vault_group_manage_vault_close',
  vault_group_manage_vault_add_path: 'vault_group_manage_vault_add_path',
  vault_group_manage_vault_remove_path: 'vault_group_manage_vault_remove_path',

  discovery_setup_start: 'discovery_setup_start',
  discovery_setup_close: 'discovery_setup_close',
  discovery_setup_create_discovery_path: 'discovery_setup_create_discovery_path',
  discovery_setup_remove_discovery_path: 'discovery_setup_remove_discovery_path',
  discovery_setup_create_discovery_path_template: 'discovery_setup_create_discovery_path_template',
  discovery_setup_edit_discovery_path_template: 'discovery_setup_edit_discovery_path_template',
  discovery_setup_delete_discovery_path_template: 'discovery_setup_delete_discovery_path_template',
  discovery_setup_status_complete: 'discovery_setup_status_complete',

  template_linking_start: 'template_linking_start',
  template_linking_delete_form: 'template_linking_delete_form',
  template_linking_add_linked_financial_accounts: 'template_linking_add_linked_financial_accounts',
  template_linking_remove_linked_financial_accounts: 'template_linking_remove_linked_financial_accounts',
  template_linking_add_linked_records: 'template_linking_add_linked_records',
  template_linking_remove_linked_records: 'template_linking_remove_linked_records',
  template_linking_add_linked_insurance_policies: 'template_linking_add_linked_insurance_policies',
  template_linking_remove_linked_insurance_policies: 'template_linking_remove_linked_insurance_policies',
  template_linking_add_linked_entities: 'template_linking_add_linked_entities',
  template_linking_remove_linked_entities: 'template_linking_remove_linked_entities',
  template_linking_add_linked_assets: 'template_linking_add_linked_assets',
  template_linking_remove_linked_assets: 'template_linking_remove_linked_assets',
  template_linking_add_linked_security: 'template_linking_add_linked_security',
  template_linking_remove_linked_security: 'template_linking_remove_linked_security',
  template_linking_add_linked_devices: 'template_linking_add_linked_devices',
  template_linking_remove_linked_devices: 'template_linking_remove_linked_devices',
  template_linking_add_linked_instructions: 'template_linking_add_linked_instructions',
  template_linking_remove_linked_instructions: 'template_linking_remove_linked_instructions',
  template_linking_add_linked_accounts: 'template_linking_add_linked_accounts',
  template_linking_remove_linked_accounts: 'template_linking_remove_linked_accounts',
  template_linking_add_linked_contacts: 'template_linking_add_linked_contacts',
  template_linking_remove_linked_contacts: 'template_linking_remove_linked_contacts',
  template_linking_add_linked_institutions: 'template_linking_add_linked_institutions',
  template_linking_remove_linked_institutions: 'template_linking_remove_linked_institutions',
  template_linking_add_linked_cryptocurrency: 'template_linking_add_linked_cryptocurrency',
  template_linking_remove_linked_cryptocurrency: 'template_linking_remove_linked_cryptocurrency',
  template_linking_add_linked_cryptocurrency_wallets: 'template_linking_add_linked_cryptocurrency_wallets',
  template_linking_remove_linked_cryptocurrency_wallets: 'template_linking_remove_linked_cryptocurrency_wallets',
  template_linking_add_linked_exchange_accounts: 'template_linking_add_linked_exchange_accounts',
  template_linking_remove_linked_exchange_accounts: 'template_linking_remove_linked_exchange_accounts',
  template_linking_add_linked_exchange_wallets: 'template_linking_add_linked_exchange_wallets',
  template_linking_remove_linked_exchange_wallets: 'template_linking_remove_linked_exchange_wallets',
  template_linking_add_linked_holdings: 'template_linking_add_linked_holdings',
  template_linking_remove_linked_holdings: 'template_linking_remove_linked_holdings',
  template_linking_add_physical_location: 'template_linking_add_physical_location',
  template_linking_remove_physical_location: 'template_linking_remove_physical_location',
  template_linking_add_password_location: 'template_linking_add_password_location',
  template_linking_remove_password_location: 'template_linking_remove_password_location',
  template_linking_status_complete: 'template_linking_status_complete',
  template_linking_close: 'template_linking_close',

  template_setup_start: 'template_setup_start',
  template_setup_add_vault: 'template_setup_add_vault',
  template_setup_add_attachment: 'template_setup_add_attachment',
  template_setup_rename_attachment: 'template_setup_rename_attachment',
  template_setup_delete_attachment: 'template_setup_delete_attachment',
  template_setup_attachment_status_change: 'template_setup_attachment_status_change',
  template_setup_add_general_information: 'template_setup_add_general_information',
  template_setup_add_description: 'template_setup_add_description',
  template_setup_add_insurance_attributes: 'template_setup_add_insurance_attributes',
  template_setup_edit_insurance_attributes: 'template_setup_edit_insurance_attributes',
  template_setup_delete_insurance_attributes: 'template_setup_delete_insurance_attributes',
  template_setup_add_financial_attributes: 'template_setup_add_financial_attributes',
  template_setup_edit_financial_attributes: 'template_setup_edit_financial_attributes',
  template_setup_delete_financial_attributes: 'template_setup_delete_financial_attributes',
  template_setup_add_role_players: 'template_setup_add_role_players',
  template_setup_edit_role_players: 'template_setup_edit_role_players',
  template_setup_delete_role_players: 'template_setup_delete_role_players',
  template_setup_add_share: 'template_setup_add_share',
  template_setup_edit_share: 'template_setup_edit_share',
  template_setup_remove_share: 'template_setup_remove_share',
  template_setup_add_note: 'template_setup_add_note',
  template_setup_edit_note: 'template_setup_edit_note',
  template_setup_delete_note: 'template_setup_delete_note',
  template_setup_add_reminder: 'template_setup_add_reminder',
  template_setup_edit_reminder: 'template_setup_edit_reminder',
  template_setup_delete_reminder: 'template_setup_delete_reminder',
  template_setup_add_attributes: 'template_setup_add_attributes',
  template_setup_add_live_date_feeds: 'template_setup_add_live_date_feeds',
  template_setup_close: 'template_setup_close',
  template_setup_status_complete: 'template_setup_status_complete',

  template_view_add_insurance_attributes: 'template_view_add_insurance_attributes',
  template_view_edit_insurance_attributes: 'template_view_edit_insurance_attributes',
  template_view_delete_insurance_attributes: 'template_view_delete_insurance_attributes',
  template_view_add_financial_attributes: 'template_view_add_financial_attributes',
  template_view_edit_financial_attributes: 'template_view_edit_financial_attributes',
  template_view_delete_financial_attributes: 'template_view_delete_financial_attributes',
  template_view_add_role_players: 'template_view_add_role_players',
  template_view_edit_role_players: 'template_view_edit_role_players',
  template_view_delete_role_players: 'template_view_delete_role_players',
  template_view_add_share: 'template_view_add_share',
  template_view_edit_share: 'template_view_edit_share',
  template_view_remove_share: 'template_view_remove_share',
  template_view_add_note: 'template_view_add_note',
  template_view_edit_note: 'template_view_edit_note',
  template_view_delete_note: 'template_view_delete_note',
  template_view_add_reminder: 'template_view_add_reminder',
  template_view_edit_reminder: 'template_view_edit_reminder',
  template_view_delete_reminder: 'template_view_delete_reminder',

  document_checklist_start: 'document_checklist_start',
  document_checklist_close: 'document_checklist_close',
  document_checklist_add_attachment: 'document_checklist_add_attachment',
  document_checklist_rename_attachment: 'document_checklist_rename_attachment',
  document_checklist_delete_attachment: 'document_checklist_delete_attachment',
  document_checklist_delete_multiple_items: 'document_checklist_delete_multiple_items',
  document_checklist_delete_suggested_attachment: 'document_checklist_delete_suggested_attachment',
};

export type EventNames = (typeof EVENTS)[keyof typeof EVENTS];
